exports.linkResolver = (doc) => {
  if (doc.uid !== 'index' && doc.type === 'page') return `/${doc.uid}/`
  if (doc.type === 'blogpost') return `/blog/${doc.uid}/`
  if (doc.type === 'case_study') return `/case-studies/${doc.uid}/`
  if (doc.type === 'vacancy') return `/vacancies/${doc.uid}/`
  if (doc.type === 'team_member') return `/our-people/${doc.uid}/`
  return '/'
}
